/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { translate } from '@utils/i18n';
import DetailSection from '@components/v2/DetailSection';
import { namespace } from '../constants';
import RichContentEntryComponent from './RichContentEntry';
import './RichContentSectionStyles.scss';
// eslint-disable-next-line import/prefer-default-export
export default function RichContentSection({ title, entries, fieldType, onAddEntry, onUpdateEntry, onDeleteEntry }) {
    const [isAddingEntry, setIsAddingEntry] = useState(false);
    useEffect(() => {
        setIsAddingEntry(false);
    }, [entries]);
    const handleDeleteEntry = (entryId) => {
        if (entryId) {
            onDeleteEntry(entryId);
        }
        else {
            setIsAddingEntry(false);
        }
    };
    return (React.createElement(DetailSection, { title: title, action: translate('content_sections.add_entry', { namespace, type: title }), onActionClick: () => setIsAddingEntry(true) },
        React.createElement("div", { className: "rich-content-section", role: "region", "aria-label": `section-${fieldType}` },
            React.createElement("div", { className: "entries-container", role: "list", "aria-label": `${title} entries` },
                entries.map((entry) => (React.createElement("div", { role: "listitem", key: entry.id },
                    React.createElement(RichContentEntryComponent, { entry: entry, fieldType: fieldType, onUpdate: onUpdateEntry, onDelete: handleDeleteEntry, onAddEntry: onAddEntry })))),
                isAddingEntry && (React.createElement("div", { role: "listitem" },
                    React.createElement(RichContentEntryComponent, { entry: {
                            id: 0,
                            body: ''
                        }, fieldType: fieldType, onUpdate: onUpdateEntry, onDelete: handleDeleteEntry, onAddEntry: onAddEntry })))))));
}
